// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import loadBackOrders from "@rc/App/Handlers/Data/BackOrder/LoadBackOrders";
import { CustomAppState } from "@rc/App/Store/Reducers";
import { BackOrderDataViewContext, getBackOrderDataView } from "@rc/App/Store/Selectors/BackOrderSelector";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomAppState) => ({
    getBackOrderApiParameter: state.xBackOrderListState?.getBackOrderApiParameter,
    backOrderDataView: getBackOrderDataView(state, state.xBackOrderListState?.getBackOrderApiParameter),
});

const mapDispatchToProps = {
    loadBackOrders,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const BackOrderList = ({ id, getBackOrderApiParameter, backOrderDataView, loadBackOrders }: Props) => {
    useEffect(() => {
        // if this is undefined it means someone changed the filters and we haven't loaded the new collection yet
        if (backOrderDataView && !backOrderDataView.value && !backOrderDataView.isLoading) {
            loadBackOrders(getBackOrderApiParameter);
        }
    });

    return (
        <StyledWrapper>
            <BackOrderDataViewContext.Provider value={backOrderDataView}>
                <Zone contentId={id} zoneName="Content" />
            </BackOrderDataViewContext.Provider>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(BackOrderList),
    definition: {
        group: "XNGAGE" as any,
        displayName: "Back Order List",
    },
};


export default widgetModule;
